export const UPDATE_MEDIA_REQUEST = "UPDATE_MEDIA_REQUEST"
export const UPDATE_MEDIA_SUCCESS = "UPDATE_MEDIA_SUCCESS"
export const UPDATE_MEDIA_FAIL = "UPDATE_MEDIA_FAIL"


export const UPDATE_MEDIA_CLEAR_STATE = "UPDATE_MEDIA_CLEAR_STATE"
export const UPDATE_MEDIA_CLEAR_ERROR = "UPDATE_MEDIA_CLEAR_ERROR"